import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

export interface EventData {
    event_content_idx: number;
    depth1_idx: number;
    depth1: string;
    depth2: string | null;
}

interface GetEventResponse {
    data: EventData[];
}

export const useGetCommonEvent = (depth1_idx?: number, customer_idx?: number): UseQueryResult<GetEventResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetEventResponse, Error>({
        queryKey: ["getCommonEvent", depth1_idx, customer_idx],
        queryFn: async () => {
            const params: Record<string, number> = {};
            if (depth1_idx) params.depth1_idx = depth1_idx;
            if (customer_idx) params.customer_idx = customer_idx;
            const response = await axios.get(`${enum_api_uri.common_get_event}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params,
            });
            return response.data;
        },
    });
};
